module.exports = __webpack_public_path__ + "static/media/3545.547049e8.jpg";